import React from "react";
import { CalendarClock } from "lucide-react";

const STYLES = {
  "Available Now": "border-emerald-200 bg-emerald-50 text-emerald-700",
  "Available Soon": "border-amber-200 bg-amber-50 text-amber-700",
  "Not Currently Available": "border-rose-200 bg-rose-50 text-rose-700",
};

export default function AvailabilityPill({ status, className = "" }) {
  if (!status) {
    return <span className={`text-xs text-slate-400 ${className}`} data-testid="availability-pill-none">Not set</span>;
  }
  const style = STYLES[status] || "border-slate-200 bg-slate-50 text-slate-600";
  return (
    <span
      className={`inline-flex items-center gap-1 rounded-full border px-2 py-0.5 text-xs font-semibold ${style} ${className}`}
      data-testid="availability-pill"
    >
      <CalendarClock className="h-3 w-3" /> {status}
    </span>
  );
}
